import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import {
  PaymentMethod,
  useBillingInformationsByOrga,
  usePaymentMethods,
} from '@app/api';
import { Theme } from '@app/theme';
import { PaymentMethodBlock } from './PaymentMethodBlock';
import moment from 'moment';
import { useUsablePaymentMethods } from './useUsablePaymentMethods';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {},
  icon: {
    fontSize: 20,
  },
}));

interface Props {
  organizationId: string;
  onSelect?: (id: string) => any;
  children?: (paymentMethod: PaymentMethod) => React.ReactNode;
  selected?: string;
  sessionId?: string;
  justAdded?: string[];
  filter?: 'all' | 'usable' | 'notUsable';
  elementClassName?: string;
}

export const PaymentMethodsList = ({
  children,
  organizationId,
  onSelect,
  selected,
  sessionId,
  filter = 'usable',
  justAdded = [],
  elementClassName,
}: Props) => {
  const classes = useStyles();

  const { paymentMethods, isLoading } = useUsablePaymentMethods(
    organizationId,
    sessionId,
    filter,
    justAdded,
  );
  const { data: info } = useBillingInformationsByOrga(organizationId);

  return (
    <div className={classes.container}>
      {paymentMethods?.map((paymentMethod) => (
        <PaymentMethodBlock
          key={paymentMethod.id}
          paymentMethod={paymentMethod}
          onClick={onSelect}
          isDefault={paymentMethod.id === info?.defaultPaymentMethodId}
          selected={paymentMethod.id === selected}
          className={elementClassName}
        >
          {children ? children(paymentMethod) : null}
        </PaymentMethodBlock>
      ))}

      {isLoading && !paymentMethods && (
        <>
          <PaymentMethodBlock onClick={onSelect} />
          <PaymentMethodBlock onClick={onSelect} />
          <PaymentMethodBlock onClick={onSelect} />
        </>
      )}
    </div>
  );
};
